import React, { forwardRef, type CSSProperties } from 'react';

interface Props {
  children: React.ReactNode;
  showHorizontalOverviewList: boolean;
}

export const LIST_ID = 'editor-overview-list';

export const OverviewListStyleWrapper = forwardRef<HTMLOListElement, Props>(
  ({ children, showHorizontalOverviewList }: Props, ref) => {
    const listStyling = showHorizontalOverviewList
      ? {
          display: 'flex',
          flexDirection: 'row',
          alignContent: 'flex-start',
          width: '100%',
          overflowX: 'auto',
        }
      : {
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'nowrap',
          alignContent: 'flex-start',
          listStyle: 'none',
          width: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
          flex: 1,
          paddingTop: '6px',
          position: 'relative',
        };

    return (
      <ol
        id={LIST_ID}
        data-testid={LIST_ID}
        ref={ref}
        style={listStyling as CSSProperties}
      >
        {children}
      </ol>
    );
  },
);
